import { useEffect, useState } from 'react';
import styles from './AuthPages.module.css';

const API = '/api/auth';

export function VerifyEmailPage() {
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found in the link.');
      return;
    }
    fetch(`${API}/verify-email?token=${encodeURIComponent(token)}`, { method: 'POST' })
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus('success');
          setMessage(data.detail || 'Email verified!');
        } else {
          setStatus('error');
          setMessage(data.detail || 'Verification failed.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Could not reach the server. Please try again.');
      });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>TrackAnalysis</h1>
        {status === 'verifying' && <p className={styles.info}>Verifying your email…</p>}
        {status === 'success' && (
          <>
            <p className={styles.success}>{message}</p>
            <a className={styles.btn} href="/app">Go to app</a>
          </>
        )}
        {status === 'error' && (
          <>
            <p className={styles.error}>{message}</p>
            <a className={styles.btn} href="/app">Go to app</a>
          </>
        )}
      </div>
    </div>
  );
}

export function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [message, setMessage] = useState('');
  const token = new URLSearchParams(window.location.search).get('token');

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirm) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setStatus('error');
      setMessage('Password must be at least 8 characters.');
      return;
    }
    setStatus('submitting');
    try {
      const res = await fetch(`${API}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus('success');
        setMessage(data.detail || 'Password updated!');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Reset failed.');
      }
    } catch {
      setStatus('error');
      setMessage('Could not reach the server. Please try again.');
    }
  }

  if (!token) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <h1 className={styles.title}>TrackAnalysis</h1>
          <p className={styles.error}>Invalid reset link.</p>
          <a className={styles.btn} href="/app">Go to app</a>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>TrackAnalysis</h1>
        <h2 className={styles.subtitle}>Set a new password</h2>
        {status === 'success' ? (
          <>
            <p className={styles.success}>{message}</p>
            <a className={styles.btn} href="/app">Go to app</a>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <input
              className={styles.input}
              type="password"
              placeholder="New password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
            />
            <input
              className={styles.input}
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />
            {status === 'error' && <p className={styles.error}>{message}</p>}
            <button className={styles.btn} type="submit" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Saving…' : 'Set password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
